"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidShippingError = exports.ShippingError = exports.ShippingErrors = exports.UNEXPECTED_ERROR = void 0;
exports.UNEXPECTED_ERROR = 'UNEXPECTED';
exports.ShippingErrors = ['SHIPPING_CONTACT_INVALID', 'SHIPPING_ADDRESS_UNSERVICEABLE', 'SHIPPING_UNKNOWN'];
exports.ShippingError = {
    SHIPPING_CONTACT_INVALID: 0,
    SHIPPING_ADDRESS_UNSERVICEABLE: 1,
    SHIPPING_UNKNOWN: 2,
};
var isValidShippingError = function (error) {
    return Object.values(exports.ShippingError).includes(error);
};
exports.isValidShippingError = isValidShippingError;
//# sourceMappingURL=Shipping.js.map